@if (emptyList()) {
  <ng-container *ngTemplateOutlet="empty" />
} @else {
  <app-table
    [columns]="tableColumnsService.visibleColumns()"
    [datas]="tableData()"
    [actions]="actions()"
    (columnsChange)="tableColumnsService.reorderColumns($event)"
    [skeletonCount]="skeletonCount()"
  />

  <app-paginator
    [isLoading]="!tableData()"
    [page]="gpsOnlyTableContentService.currentPage()"
    [totalItems]="gpsOnlyTableContentService.totalItems()"
    [itemsPerPage]="gpsOnlyTableContentService.contentLimitPerPage()"
    (nextPage)="gpsOnlyTableContentService.nextPage()"
    (previousPage)="gpsOnlyTableContentService.previousPage()"
    [firstItemInCurrentPage]="gpsOnlyTableContentService.firstItemInPage()"
    [lastItemInCurrentPage]="gpsOnlyTableContentService.lastItemInPage()"
    [lastPage]="gpsOnlyTableContentService.lastPage()"
    (goToPage)="gpsOnlyTableContentService.goToPage($event)"
    (setItemPerPage)="gpsOnlyTableContentService.setItemPerPage($event)"
  />
}

<ng-template #empty>
  <app-empty-content-list-element contentType="gps-track" />
</ng-template>
